import {
  MyHRAdminAddGroupRolesPage,
  MyHRAdminInactivateGroupPage,
  MyHRAdminRemoveGroupPage,
  MyHRAdminSendGroupPasswordsPage,
  MyHRAdminSettingsPage,
  MyHRAdminSystemSettingsPage,
  MyHRAdminUserPage,
  MyHRAdminUsersPage,
  MyHRCreateNewUserPage,
  MyHRErrorPage,
  MyHRMyInfoPage,
  MyHROwadminAddPermitPage,
  MyHROwadminLoginPage,
  MyHRServiceLoginPage,
  MyHRUserForgotPasswordPage,
  MyHRUserGuidesPage,
  MyHRUserLoginPage,
  MyHRUserProfilePage,
  MyHRUserRequestsPage,
  MyHrUserDataEditRequestsPage,
} from "my-hr/pages";
import { OcHomePageWrapper } from "oc/pages/oc-home-page-wrapper";

export const myHomePageRoutePath = "/";
export const myHRMyInfoPageRoutePath = "/my-hr/my-info";
export const myHRMyProfilePageRoutePath = "/my-hr/my-profile";
export const myHRUserGuidesPageRoutePath = "/my-hr/user-guides";
export const myHRMyRequestsPageRoutePath = "/my-hr/my-requests";
export const myHRViewRequestsPageRoutePath = "/my-hr/view-requests";
export const myHRViewRequestPageRoutePath = "/my-hr/view-request/:employee";
export const myHRCreateNewUserPageRoutePath = "/my-hr/create-new-user";
export const myHRSystemSettingsPageRoutePath = "/my-hr/system-settings";
export const myHRAdminSettingsPageRoutePath = "/my-hr/admin/settings";
export const myHRAdminUserPageRoutePath = "/my-hr/user-profile/:employee";
export const myHRAdminUsersPageRoutePath = "/my-hr/users";
export const myHRUserLoginPageRoutePath = "/login";
export const myHRUserForgotPasswordPageRoutePath = "/forgot-password";
export const myHRAdminAddGroupRolesPageRoutePath =
  "/my-hr/users/add-group-roles";
export const myHRAdminInactivateGroupPageRoutePath =
  "/my-hr/users/inactivate-group";
export const myHRAdminRemoveGroupPageRoutePath = "/my-hr/users/remove-group";
export const myHRAdminSendGroupPasswordsPageRoutePath =
  "/my-hr/users/send-group-passwords";
export const myHRErrorPageRoutePath = "/my-hr/connection-error";
export const myHROwadminLoginPageRoutePath = "/ow-admin-login";
export const myHROwadminAddPermitPageRoutePath = "/ow-admin-add-permit";
export const myHRServiceLoginPageRoutePath = "/service-login";

export const buildMyHRViewRequestPageRoutePath = (employee: string) =>
  `/my-hr/view-request/${employee}`;
export const bildMyHRAdminUserPageRoutePath = (employee: string) =>
  `/my-hr/user-profile/${employee}`;

export const myHRRoutes = [
  {
    id: "myHomePageRoute",
    path: myHomePageRoutePath,
    exact: true,
    private: true,
    component: OcHomePageWrapper,
    roles: ["MyHR.user"],
  },
  {
    id: "myHRMyInfoPageRoute",
    path: myHRMyInfoPageRoutePath,
    exact: true,
    private: true,
    component: MyHRMyInfoPage,
    roles: ["MyHR.user"],
  },
  {
    id: "myHRMyProfilePageRoute",
    path: myHRMyProfilePageRoutePath,
    exact: true,
    private: true,
    component: MyHRUserProfilePage,
    roles: ["MyHR.user"],
  },
  {
    id: "myHRUserGuidesPageRoute",
    path: myHRUserGuidesPageRoutePath,
    exact: true,
    private: true,
    component: MyHRUserGuidesPage,
    roles: ["MyHR.user"],
  },
  {
    id: "myHRMyRequestsPageRoute",
    path: myHRMyRequestsPageRoutePath,
    exact: true,
    private: true,
    component: MyHrUserDataEditRequestsPage,
    roles: ["MyHR.user"],
  },
  {
    id: "myHRViewRequestsPageRoute",
    path: myHRViewRequestsPageRoutePath,
    exact: true,
    private: true,
    component: MyHRUserRequestsPage,
    roles: ["MyHR.examiner"],
  },
  {
    id: "myHRViewRequestPageRoute",
    path: myHRViewRequestPageRoutePath,
    exact: true,
    private: true,
    component: MyHrUserDataEditRequestsPage,
    roles: ["MyHR.user"],
  },
  {
    id: "myHRCreateNewUserPageRoute",
    path: myHRCreateNewUserPageRoutePath,
    exact: true,
    private: true,
    component: MyHRCreateNewUserPage,
    roles: ["MyHR.admin"],
  },
  {
    id: "myHRSystemSettingsPageRoute",
    path: myHRSystemSettingsPageRoutePath,
    exact: true,
    private: true,
    component: MyHRAdminSystemSettingsPage,
    roles: ["MyHR.admin"],
  },
  {
    id: "myHRAdminSettingsPageRoute",
    path: myHRAdminSettingsPageRoutePath,
    exact: true,
    private: true,
    component: MyHRAdminSettingsPage,
    roles: ["MyHR.admin"],
  },
  {
    id: "myHRAdminUserPageRoute",
    path: myHRAdminUserPageRoutePath,
    exact: true,
    private: true,
    component: MyHRAdminUserPage,
    roles: ["MyHR.admin"],
  },
  {
    id: "myHRAdminUsersPageRoute",
    path: myHRAdminUsersPageRoutePath,
    exact: true,
    private: true,
    component: MyHRAdminUsersPage,
    roles: ["MyHR.admin"],
  },
  {
    id: "myHRUserLoginPageRoute",
    path: myHRUserLoginPageRoutePath,
    exact: true,
    private: false,
    component: MyHRUserLoginPage,
  },
  {
    id: "myHRUserForgotPasswordPageRoute",
    path: myHRUserForgotPasswordPageRoutePath,
    exact: true,
    private: false,
    component: MyHRUserForgotPasswordPage,
  },
  {
    id: "myHRAdminAddGroupRolesPageRoute",
    path: myHRAdminAddGroupRolesPageRoutePath,
    exact: true,
    private: true,
    component: MyHRAdminAddGroupRolesPage,
    roles: ["MyHR.admin"],
  },
  {
    id: "myHRAdminInactivateGroupPageRoute",
    path: myHRAdminInactivateGroupPageRoutePath,
    exact: true,
    private: true,
    component: MyHRAdminInactivateGroupPage,
    roles: ["MyHR.admin"],
  },
  {
    id: "myHRAdminRemoveGroupPageRoute",
    path: myHRAdminRemoveGroupPageRoutePath,
    exact: true,
    private: true,
    component: MyHRAdminRemoveGroupPage,
    roles: ["MyHR.admin"],
  },
  {
    id: "myHRAdminSendGroupPasswordsPageRoute",
    path: myHRAdminSendGroupPasswordsPageRoutePath,
    exact: true,
    private: true,
    component: MyHRAdminSendGroupPasswordsPage,
    roles: ["MyHR.admin"],
  },
  {
    id: "myHRErrorPageRoute",
    path: myHRErrorPageRoutePath,
    exact: true,
    private: false,
    component: MyHRErrorPage,
  },
  {
    id: "myHROwadminLoginPageRoute",
    path: myHROwadminLoginPageRoutePath,
    exact: true,
    private: false,
    component: MyHROwadminLoginPage,
  },
  {
    id: "myHRServiceLoginPageRoute",
    path: myHRServiceLoginPageRoutePath,
    exact: true,
    private: false,
    component: MyHRServiceLoginPage,
  },
  {
    id: "myHROwadminAddPermitPageRoute",
    path: myHROwadminAddPermitPageRoutePath,
    exact: true,
    private: false,
    component: MyHROwadminAddPermitPage,
  },
];
